import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { addIntlProps, addProps } from 'utils/recompose';
import { mini } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import messages from './messages';
import styles from './styles.scss';

export const mapStateToProps = combineSelectors({
  mini,
});

export const remainingStatStyle = ({ remaining }) =>
  remaining === 0 ? styles.statNumberInactive : styles.statNumber;

export const submittedStatStyle = ({ submitted }) =>
  submitted === 0 ? styles.statNumberInactive : styles.statNumber;

export const inCartStatStyle = ({ inCart }) =>
  inCart === 0 ? styles.statNumberInactive : styles.statNumber;

export default compose(
  injectIntl,
  connect(mapStateToProps),
  addIntlProps({
    messages,
    propNames: ['remainingQuotaLabel', 'inCartLabel', 'submittedLabel'],
  }),
  addProps({
    remainingStatStyle,
    submittedStatStyle,
    inCartStatStyle,
  }),
);
